function updateCartIcon() {
  const cartIcon = $("#CartCount");
  $.getJSON('/cart.js', function(cart) { cartIcon.html(cart.item_count); });
}

$(document).ready(function () {
  // Fetch Full Collection
  const collection = $(".vcollection-grid");
  
  if (collection && collection.attr('data-collection') != '') {
    const collection_pages = collection.attr('data-paginate');
    let collection_url = collection.attr('data-collection');
    collection_url += '?page=';
    for (let i = 2; i <= collection_pages; i++) {
      var collection_page_url = collection_url+i;

      $.get(collection_page_url, function(data) {
        var page = $(data);
        var items = page.find('.vcollection-item');
        collection.append(items);

        if (i == collection_pages) {
          //setTimeout(window.hideNotAvailable, 500);
        }
      });
    }
  }

  let variantItems = {
    init: function() {
      variantItems.getAllProducts().then(data => {
        window.Shopify.all_products = data.all_products;
        variantItems.showOtherPacks();
      });
    },
    
    getAllProducts: async function() {
      const response = await fetch("/collections/todos-los-productos?view=api-all-products");
      // console.log(response.json())
      return response.json();
    },
  
    getProduct: function(handle) {
      return window.Shopify.all_products[handle]; 
    },
  
    showOtherPacks: function() {
      const all_packages = document.querySelectorAll(".pack-sizes");
  
      for (let product_packages of all_packages) {
        const default_package = product_packages.querySelector("input");
        const product_handle = product_packages.getAttribute("data-product");
  
        if (product_handle != '') {
          const product_metafields = variantItems.getProduct(product_handle).metafields;
          const related_products = product_metafields.related_products;
          const product_id = default_package.getAttribute("name");
          let other_sizes = "";
  
          related_products[0].forEach((rel_handle,key) => {
            const rel_product = variantItems.getProduct(rel_handle);
//             if (rel_product && rel_product.metafields.pack_size) {
            if (rel_product) {
              // let unit_suffix = "";
              // if (rel_product.metafields.product_unit) { 
              //   unit_suffix = ` ${rel_product.metafields.product_unit}`; 
              // } else if (rel_product.title.includes("ml")) { 
              //   unit_suffix = " ml"; 
              // }
              const on_sale = (rel_product.variants[0].compare_at_price && rel_product.variants[0].price < rel_product.variants[0].compare_at_price) ? 'data-sale="true"' : 'data-sale="false"';
              const product_title = (rel_product.metafields.product_title) ? rel_product.metafields.product_title : rel_product.title;
              let grammature = rel_product.metafields.pack_size_grams ? rel_product.metafields.pack_size_grams : '100000';
              other_sizes += `<label class="pack-sizes__label" style="order: ${grammature}"><input type="radio" name="${product_id}" value="${rel_product.variants[0].id}" data-available="${rel_product.available}" data-handle="${rel_product.handle}" data-image="${rel_product.images[0]}" ${on_sale} data-price="${rel_product.variants[0].price}" data-compareatprice="${rel_product.variants[0].compare_at_price }" data-title="${product_title}" data-url="${rel_product.url}" data-rating="${rel_product.rating}"><div class="pack-sizes__item">${rel_product.metafields.pack_size}</div></label>`
            }
            else {
//               console.log(rel_handle);
            }
          });
  
          product_packages.innerHTML += other_sizes;
          product_packages.style.display = 'flex';
        }
      }
  
      variantItems.initVariantHandlers();
    },
  
    initVariantHandlers: function() {
      const all_variants = document.querySelectorAll(".pack-sizes input");
  
      for (let variant of all_variants) {
        variant.addEventListener("change", function(e) {
          const product_item = e.currentTarget.closest(".vcollection-item");
          const product = e.currentTarget;
          const product_data = product.dataset;
          
          const product_template = {
            title: product_item.querySelector(".vcollection-item__title"),
            image: product_item.querySelector(".vcollection-item__image-box img"),
            link: product_item.querySelector("a"),
            quickviewHandle: product_item.querySelector('.btnProductQuickview'),
            button: product_item.querySelector(".js-add-product"),
            price: product_item.querySelector(".vcollection-item__prices"),
            rating: product_item.querySelector(".product-rate")
            // saved: product_item.querySelector(".product-item__saved")
          };
          
          product_template.title.innerHTML = product_data.title;
          product_template.image.setAttribute("src", product_data.image);
          product_template.link.setAttribute("href", product_data.url);
          product_template.quickviewHandle.setAttribute('data-handle',product_data.handle)
          product_template.button.setAttribute("data-variant", product.value);
          product_template.rating.className = `product-rate product-rate--${product_data.rating}`
          if (product_data.available == 'true') {
            var product_button_text = product_template.button.getAttribute('data-add');
            product_template.button.disabled = false;
            product_template.button.innerHTML = product_button_text;
          } else {
            var product_button_text = product_template.button.getAttribute('data-soldout');
            product_template.button.disabled = true;
            product_template.button.innerHTML = product_button_text;
          }
          const product_price = (product_data.compareatprice >= product_data.price || product_data.compareatprice == "" || product_data.compareatprice == "null") ? `<span class="vcollection-item__price--regular">&euro;${product_data.price / 100}</span>` : `<span class="vcollection-item__price--sale">&euro;${product_data.price / 100}</span><span class="vcollection-item__price--old">&euro;${product_data.compareatprice / 100}</span>` ;
          product_template.price.innerHTML = product_price.replace(/\./g,',');
        });
      }

      const filterOnEnter = function() {

        let currentParams = new URLSearchParams(window.location.search);
        let paramArr = [];
        if (currentParams.get('filter') != null) paramArr = currentParams.get('filter').split(',');
        let filterOptions = $('.collectionFilters__filter__option');
        filterOptions.each(function(){
            $this = $(this);
            paramArr.forEach(value => {
                if ($this.data('option') == value) {
                    $this.addClass('active')
                }
            })
        });

        let $activeFilters = $('.collectionFilters__filter__option.active');
        let ageTagsArr = [];
        let formulaTagsArr = [];
        let dpTagsArr = [];
        let $productNodes = $('.vcollection-item');

        const handleizeFilter = filter => {
            let handleizedString = filter.toLowerCase().replace(/ /g,'-');
            handleizedString = handleizedString.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            handleizedString = handleizedString.replace(/\./g,'-').replace(/\--/g,'-');
            return handleizedString;
        }

        $activeFilters.each(function(){
            let option = $(this).data('option').split('_');
            switch (option[0]) {
                case "age":
                    ageTagsArr.push(handleizeFilter(option[1]))
                    break;
                case "formula":
                    formulaTagsArr.push(handleizeFilter(option[1]))
                    break;
                case "dp":
                    dpTagsArr.push(handleizeFilter(option[1]))
                    break;
            }
        });
        if (ageTagsArr.length == 0 && formulaTagsArr.length == 0  && dpTagsArr.length == 0) {
            $productNodes.show();
        }
        else {
            $productNodes.each(function(){
                const $product = $(this);
                let itemTags = $product.data('tags').split(',');
                let filterMatch = [];
                const compareArrays = (arr, target) => target.every(v => arr.includes(v));
                $product.hide();
                if (ageTagsArr.length != 0) {
                    let tagMatch = compareArrays(itemTags,ageTagsArr);
                    if(tagMatch) filterMatch.push(true);
                    else filterMatch.push(false);
                }
                if (formulaTagsArr.length != 0) {
                    let tagMatch = compareArrays(itemTags,formulaTagsArr);
                    if(tagMatch) filterMatch.push(true);
                    else filterMatch.push(false);
                }
                if (dpTagsArr.length != 0) {
                    let tagMatch = compareArrays(itemTags,dpTagsArr);
                    if(tagMatch) filterMatch.push(true);
                    else filterMatch.push(false);
                }
                const productMatch = $.inArray(false,filterMatch);
                if (productMatch == -1) {
                    $product.show();
                }
                filterMatch = [];

            })
        }
      }
      filterOnEnter();
      
    }
  }
  variantItems.init();

  // // Clear Not Available
  // $(".vcollection-item").each(function (i, element) {
  //   var item = $(element);
  //   var variants = item.find('.vcollection-item__variants');
  //   var firstOption = $(variants.find('.vcollection-item__variant:first-child'));

  //   if (firstOption.attr('data-available') == 'false' && variants.find('.vcollection-item__variant').length > 1) {
  //     var isAvailable = false;
  //     $(variants.find('.vcollection-item__variant')).each(function (iE, option) {
  //       var option = $(option);
  //       if (option.attr('data-available') == 'true' && isAvailable == false) {
  //         option.trigger('click');
  //         isAvailable = true;
  //         return;
  //       }
  //     });

  //     if (isAvailable == false) {
  //       firstOption.trigger('click');
  //     }
  //   } else {
  //     firstOption.trigger('click');
  //   }
  // });

  // Switch Variant
  $('body').on('click', '.vcollection-item__variant', function (e) {
    var product = $(e.target).closest('.vcollection-item');
    var variant = $(e.currentTarget);
    var inputID = variant.find('input');

    var product_form = product.find('.vcollection-item__form');
    product_form.removeClass('edit');
    product_form.find("input[name='form_type']").val('product');
    product_form.find("input[name='utf8']").val('✓');

    var product_button = product.find('.js-add-product');
    if (variant.attr('data-available') == 'true') {
      var product_button_text = product_button.attr('data-add');
      product_button.attr('data-variant', inputID.attr('value'));
      product_button.removeAttr('data-added data-key');
      product_button.removeClass('btn--border');
      product_button.prop('disabled', false);
      product_button.html(product_button_text);
    } else {
      var product_button_text = product_button.attr('data-soldout');
      product_button.attr('data-variant', inputID.attr('value'));
      product_button.removeAttr('data-added data-key');
      product_button.removeClass('btn--border');
      product_button.prop('disabled', true);
      product_button.html(product_button_text);
    }

    var product_image = product.find('.vcollection-item__image');
    product_image.attr('src', variant.attr('data-image'));

    var product_url = variant.attr('data-url');
    product.find('.vcollection-item__link').attr('href', product_url);

    var product_handle = variant.attr('data-handle');
    product.find('button.btnProductQuickview').attr('data-handle', product_handle);

    var original_price = variant.attr('data-price');
    var compare_at_price = variant.attr('data-compare-at-price');
    var product_price = product.find('.vcollection-item__prices');
    product_price.html('');
    if (compare_at_price > original_price) {
      var price = (original_price / 100) + " zł";
      price = price.replace(".", ",");
      var priceOld = (compare_at_price / 100) + " zł";
      priceOld = priceOld.replace(".", ",");
      var priceElem = $("<span>").addClass('vcollection-item__price--sale').html(price);
      var priceOld = $("<span>").addClass('vcollection-item__price--old').html(priceOld);
      product_price.append(priceElem, priceOld);
    } else {
      var price = (original_price / 100) + " zł";
      price = price.replace(".", ",");
      var priceElem = $("<span>").addClass('vcollection-item__price--regular').html(price);
      product_price.append(priceElem);
    }
  });

  $('body').on('click', '.js-add-product', function (e) {
    e.preventDefault();
    const button = $(this);
    const variantID = button.attr('data-variant');

    if (button.attr('data-added') == 'true') {
      window.top.location = "/cart";
    } else {
      button.addClass("loading");

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: { quantity: 1, id: variantID },
        success: function() {
          button.removeClass("loading").attr('data-added','true').html("Ver carrito");
          updateCartIcon();
          if (window.location.pathname == "/cart") {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
            window.location.reload()
          }
        },
        error: function(err) {
          console.log("Error: ", err);
        }
      });
    }
  });
});